import { StaticVideo } from '@/types/video.types';
import { Put } from '../helpers';

export const updateVideo = (video: StaticVideo): Promise<StaticVideo> => {
  return Put({
    path: `/v4/videos/channel/${video.channel}/videos/${video.uuid}`,
    body: video,
  });
};
